import React from 'react'
import { Accordion, Block } from '@components'

const DatoCmsAccordion = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <Accordion {...props} />
    </Block>
  )
}

export default DatoCmsAccordion
